export default (state = [], action) => {
	switch (action.type) {
		case "SELECT_LANGUAGE":
			return action.language;
		default:
			return state;
	}
};
